import type { AxiosErrorMap } from '@/shared/lib/http/axios-adapter'

export function assertErrorResponse<T extends string>(
  error: AxiosErrorMap<T>,
): asserts error is AxiosErrorMap<T> & { response: NonNullable<AxiosErrorMap<T>['response']> } {
  if (!error.response?.data) {
    throw new Error('response data is required for error handling', error)
  }
}
